module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Home"
  }, [_c('Navbar'), _c('Wrapper')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12fb91af"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./src/layout/Home/Home.pug
// module id = 178
// module chunks = 1